/**
 * Rounds a number using the "banker's rounding" (round half to even) strategy.
 * When a number is exactly halfway between two integers, it rounds to the nearest even integer.
 *
 * @param num The number to round
 * @returns The rounded number
 */
const bankersRound = (num: number): number => {
  const integerPart = Math.trunc(num);
  const fractionalPart = Math.abs(num - integerPart);

  if (fractionalPart === 0.5) {
    // If exactly halfway, round to the nearest even integer
    if (integerPart % 2 === 0) {
      return integerPart; // Already even
    } else {
      // Round to the next even integer
      return num > 0 ? integerPart + 1 : integerPart - 1;
    }
  } else {
    // For other cases, use standard rounding
    return Math.round(num);
  }
};

export { bankersRound };
